export default "__VITE_ASSET__BlL_Wnwd__"